<template lang="pug">
  .links
    b-form-row.align-items-center.mt-3.mb-4
      b-col.mb-2.mb-md-0
        h4.mb-0 Enlaces
      b-col(cols="auto")
        b-button.mr-2(variant="an", :disabled="loading || busy", @click="createLinkModal = true") Crear enlace
    b-row.h-100.overflow-y
      b-col.h-100.overflow-md-y.scrollable-area.br-1.p-0(md="4")
        b-overlay(:show="busy", variant="transparent", spinner-variant="primary")
          empty-message(v-if="!documents.length && !busy", message="No hay enlaces creados")
          b-card(v-if="documents.length")
            b-nav(vertical, tabs)
              b-nav-item.mb-2.w-100(v-for="link in documents", :key="link.id",
                link-classes="account-link text-truncate",
                :to="{name: 'link', params: { linkId: link.id } }"
              ) {{link.name}}
      b-col
        empty-message(v-if="!$route.params.linkId  && !busy", :message="documents.length ? 'Selecciona un enlace' : 'No hay enlaces creados'")
        router-view(:key="$route.path")
    b-modal(v-model="createLinkModal",
      centered
      header-class="b-0 pb-0",
      footer-class="b-0",
      cancel-title="Cancelar",
      ok-variant="an"
      ok-title="Crear enlace",
      :ok-disabled="loading || !validLink",
      @ok="createLink",
      @hidden="linkUrl = ''"
    )
      b-form-group(label="Enlace nuevo")
        template(#description)
          p.text-secondary Por default, se extraerán los títulos y párrafos del sitio ( h1, h2, h3, span y p).
          p.mb-0 Acepta enlaces a sitios estáticos, como una página web o landing page.
          p No realiza búsquedas en páginas anidadas, es decir, páginas secundarias que están incrustadas en la página principal
        b-form-input(placeholder="Ingresa la URL del sitio", v-model="linkUrl" )

</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'

const documentsController = createNamespacedHelpers('document')

export default {
  name: 'Links',
  data () {
    return {
      loading: false,
      busy: false,
      createLinkModal: false,
      linkUrl: ''
    }
  },
  computed: {
    ...documentsController.mapState({
      documents: state => state.documents
    }),
    validLink() {
      if(!this.linkUrl) return false
      return !!this.linkUrl.match(/^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/)
    }
  },
  methods: {
    ...mapActions([
      'document/all',
      'document/createLink'
    ]),
    getLinks () {
      this.busy = true

      this['document/all']({
        accountId: this.$route.params.account_id,
        params: { type: 'link' },
        callback: res => {
          this.busy = false
          if (res.error) return this.$message.error(res.error)
          this.openFirst()
        }
      })
    },
    async createLink (bvModalEvt) {
      bvModalEvt.preventDefault()
      this.loading = true

      this['document/createLink']({
        accountId: this.$route.params.account_id,
        link: this.linkUrl,
        name: this.linkUrl,
        callback: res => {
          this.loading = this.createLinkModal = false
          if (res.error) return this.$message.error(res.error)
          this.$router.push({name: 'link', params: { linkId: res.resource } }).catch(() => {})
        }
      })
    },
    openFirst() {
      if(this.documents.length && !this.$route.params.linkId) {
        this.$router.push({name: 'link', params: { linkId: this.documents[0].id } }).catch(() => {})
      }
    },
  },
  mounted () {
    this.getLinks()
  },
}
</script>

<style lang="scss">
.account-link {
  border-radius: 5px;

  &:hover, &.router-link-exact-active {
    background: rgba(14, 92, 207, 0.1) !important;
  }
}

#document-file-input {
  .custom-file-label {
    border-style: dashed;
    height: auto;
    margin: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    position: relative;
  }
  .custom-file-input{
    position: absolute;
  }
}

.custom-file-label:after {
  display: none !important;
}
</style>